<template>
  <div class="cashback-regra-informacoes">
    <div class="cashback-regra-informacoes__section">
      <div class="cashback-regra__secao-titulo">Identificação</div>
      <CRow>
        <CCol md="9">
          <label class="cashback-regra__rotulo">Nome *</label>
          <input
            class="form-control"
            :value="item.nome"
            :maxlength="tamanhoMaximoNome"
            placeholder="Ex.: Cashback de fidelidade"
            @input="alterar('nome', $event.target.value)"
          />
        </CCol>
        <CCol md="3">
          <label class="cashback-regra__rotulo">
            Prioridade
            <HintInfo texto="Cada item do pedido gera cashback por uma única regra: a de maior prioridade entre as que incluem o item. Com prioridades iguais, vale a de maior percentual. Itens que a regra não inclui ficam para as outras regras." />
          </label>
          <input class="form-control" type="number" min="0" step="1" :value="item.prioridade" @input="alterar('prioridade', numeroDigitado($event))" />
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol md="12">
          <label class="cashback-regra__rotulo">Descrição</label>
          <textarea
            class="form-control"
            rows="2"
            :value="item.descricao"
            maxlength="500"
            placeholder="Uso interno. Não é exibida ao cliente."
            @input="alterar('descricao', $event.target.value)"
          />
        </CCol>
      </CRow>
    </div>

    <div class="cashback-regra-informacoes__section">
      <div class="cashback-regra__secao-titulo">Vigência</div>
      <CRow class="align-items-end">
        <CCol md="4">
          <label class="cashback-regra__rotulo">Início</label>
          <input class="form-control" type="date" :value="item.dataInicio" @input="alterar('dataInicio', $event.target.value || null)" />
        </CCol>
        <CCol md="4">
          <label class="cashback-regra__rotulo">Fim</label>
          <input class="form-control" type="date" :value="item.dataFim" @input="alterar('dataFim', $event.target.value || null)" />
        </CCol>
        <CCol md="4">
          <InterruptorCashback
            rotulo="Situação"
            texto-ligado="Ativa"
            texto-desligado="Inativa"
            ajuda="Regras inativas não geram cashback, mesmo dentro da vigência."
            :value="!!item.ativo"
            @input="alterar('ativo', $event)"
          />
        </CCol>
      </CRow>
      <small class="cashback-regra-informacoes__dica">Sem datas, a regra vale enquanto estiver ativa.</small>
    </div>

    <div class="cashback-regra-informacoes__section">
      <div class="cashback-regra__secao-titulo">Canais que geram cashback *</div>
      <div class="cashback-regra-informacoes__canais">
        <SelectableCard
          v-for="canal in canais"
          :key="canal.chave"
          :value="canal.chave"
          :label="canal.label"
          :description="descricaoCanal(canal.chave)"
          :image="imagemCanal(canal.chave)"
          :icon="imagemCanal(canal.chave) ? '' : 'wallet'"
          :selected="item.canais.includes(canal.chave)"
          @select="alternarCanal"
        />
      </div>
    </div>

    <div class="cashback-regra-informacoes__section">
      <div class="cashback-regra__secao-titulo">Mensagem de incentivo no checkout</div>
      <input
        class="form-control"
        :value="item.mensagemIncentivo"
        maxlength="500"
        placeholder="Compre mais R$ {VALOR_FALTA} e ganhe {PERCENTUAL_PROXIMA}% de cashback."
        @input="alterar('mensagemIncentivo', $event.target.value)"
      />
      <div class="cashback-regra-informacoes__variaveis">
        <button
          v-for="variavel in variaveis"
          :key="variavel.chave"
          type="button"
          class="cashback-regra-informacoes__variavel"
          :title="variavel.descricao"
          :aria-label="`Inserir ${variavel.chave}: ${variavel.descricao}`"
          @click="inserirVariavel(variavel.chave)"
        >
          {{ variavel.chave }}
        </button>
      </div>
      <small class="cashback-regra-informacoes__dica">Clique em uma variável para inseri-la. Em branco, usa o texto padrão.</small>
    </div>
  </div>
</template>

<script>
import InterruptorCashback from "../components/InterruptorCashback.vue";
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import HintInfo from "@/components/form/HintInfo.vue";
import { TAMANHO_MAXIMO_NOME } from "../../helpers";
import { descricaoCanal, imagemCanal } from "../../canais";

export default {
  name: "StepInformacoes",
  components: { InterruptorCashback, SelectableCard, HintInfo },

  props: {
    item: { type: Object, required: true },
    canais: { type: Array, default: () => [] },
  },

  data() {
    return {
      tamanhoMaximoNome: TAMANHO_MAXIMO_NOME,
      variaveis: [
        { chave: "{VALOR_FALTA}", descricao: "Quanto falta para a próxima faixa" },
        { chave: "{PERCENTUAL_PROXIMA}", descricao: "Percentual da próxima faixa" },
        { chave: "{PERCENTUAL_ATUAL}", descricao: "Percentual da faixa atual" },
        { chave: "{VALOR_PREVISTO}", descricao: "Cashback previsto para o pedido" },
      ],
    };
  },

  methods: {
    imagemCanal,

    descricaoCanal,

    alterar(campo, valor) {
      this.$emit("alterar", { [campo]: valor });
    },

    numeroDigitado(evento) {
      const valor = evento.target.value;

      return valor === "" ? null : Number(valor);
    },

    alternarCanal(chave) {
      const canais = this.item.canais.includes(chave) ? this.item.canais.filter((canal) => canal !== chave) : [...this.item.canais, chave];

      this.alterar("canais", canais);
    },

    inserirVariavel(chave) {
      const atual = this.item.mensagemIncentivo || "";

      this.alterar("mensagemIncentivo", atual ? `${atual} ${chave}` : chave);
    },
  },
};
</script>

<style scoped>
.cashback-regra-informacoes__section {
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.cashback-regra-informacoes__section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.cashback-regra__secao-titulo {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.cashback-regra__rotulo {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.cashback-regra-informacoes__canais {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.cashback-regra-informacoes__variaveis {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.cashback-regra-informacoes__variavel {
  border: none;
  font-family: monospace;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: #edf8f9;
  color: #2298a3;
  cursor: pointer;
}

.cashback-regra-informacoes__variavel:hover {
  background-color: #d6f0f2;
}

.cashback-regra-informacoes__dica {
  display: block;
  font-size: 11px;
  color: #999;
  margin-top: 6px;
}

@media (max-width: 768px) {
  .cashback-regra-informacoes__canais {
    grid-template-columns: 1fr;
  }
}
</style>
